import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [audios, setAudios] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/articles", { params: { media_type: "video", limit: 30 } }),
      api.get("/articles", { params: { media_type: "audio", limit: 30 } }),
    ]).then(([v, a]) => { setVideos(v.data.items || []); setAudios(a.data.items || []); });
  }, []);

  return (
    <>
      <SEO title="Video & Audio · ITTV News" description="Video reports and audio essays from ITTV News." />
      <div className="border-b" style={{ borderColor: "hsl(var(--border-hsl))" }}>
        <div className="container-editorial py-16">
          <div className="kicker text-[color:var(--accent)] mb-3">Multimedia</div>
          <h1 className="font-serif text-6xl md:text-8xl font-bold tracking-tight leading-none">Video & Audio</h1>
          <p className="mt-6 text-xl text-[color:var(--text-muted)] max-w-2xl">Long-form documentaries, on-the-ground video, and audio essays produced by the ITTV News desk.</p>
        </div>
      </div>

      <div className="container-editorial py-16">
        <h2 className="font-serif text-4xl font-bold mb-8 pb-4 border-b" style={{ borderColor: "hsl(var(--border-hsl))" }}>Video Reports</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {videos.map((v) => <ArticleCard key={v.slug} article={v} />)}
          {!videos.length && <p className="text-[color:var(--text-muted)]">No videos yet.</p>}
        </div>

        <h2 className="font-serif text-4xl font-bold mt-20 mb-8 pb-4 border-b" style={{ borderColor: "hsl(var(--border-hsl))" }}>Audio Essays</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {audios.map((a) => <ArticleCard key={a.slug} article={a} />)}
          {!audios.length && <p className="text-[color:var(--text-muted)]">No audio pieces yet.</p>}
        </div>
      </div>
    </>
  );
}
